var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isAdmin)?_c('div',{staticClass:"p-5 text-center"},[_vm._v(" Wanna do something? Click on an item in the left! ")]):_vm._e(),(_vm.isAdmin)?_c('admin-home'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }